export default class {
  // `namespace` is jQuery's own event-namespace suffix, used so a controller can unbind exactly
  // the forwarder it registered without disturbing any other handler for the same event type.
  static forwardJqueryEvent(node, jqEventName, namespace) {
    const boundName = namespace ? `${jqEventName}.${namespace}` : jqEventName
    $(node).on(boundName, event => {
      event.target.dispatchEvent(new Event(jqEventName))
    })
  }

  static stopForwardingJqueryEvents(node, namespace) {
    $(node).off(`.${namespace}`)
  }
}
